module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_diamond_hazel.ed5faa74.png";